import { render } from "./LocalOptions.vue?vue&type=template&id=73ee0498&ts=true"
import script from "./LocalOptions.vue?vue&type=script&lang=ts"
export * from "./LocalOptions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__